import React from "react";
import svg99 from "../assets/svg/svg99.svg";

function EmtyCard({ title }) {
  return (
    <div className="flex flex-col items-center">
      <img src={svg99} alt="svg99" />
      <span className="table-empty_h1 mt-[1.5rem]">No Records found</span>
      <span className=" typography_2">
        Refresh or <span className="text-[#002777] underline">Update</span> with
        new record
      </span>
    </div>
  );
}

export default EmtyCard;
